import { FontAddiFamilyIconsUrlRegular, FontAddiFormatTrueType } from '@addi/foundation/dist/web/fonts';
import { css } from 'styled-components';
const IconsFontFace = css `
  @font-face {
    font-family: 'addi-icon';
    src:  url('${FontAddiFamilyIconsUrlRegular}') format('${FontAddiFormatTrueType}');
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }
`;
export default IconsFontFace;
//# sourceMappingURL=Icons.js.map